const GameBannerContainer: FC = ({ children }) => (
  <div className="hidden h-[7.5rem] grid-flow-col grid-cols-[1fr_13.625rem_1fr_1fr_1.25rem] items-center gap-4 rounded-lg bg-gohan p-4 xl:grid 2xl:grid-cols-[1fr_13.625rem_1fr_1fr_0.4fr] 2xl:px-6 2xl:py-4">
    {children}
  </div>
);
export default GameBannerContainer;
